/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Pain_Item51Inputs */

const ja_playdata_eventreport_pain_item51 = /** @type {(inputs: Playdata_Eventreport_Pain_Item51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じゲームタイトルの他の大会と比較してみたい`)
};

const en_playdata_eventreport_pain_item51 = /** @type {(inputs: Playdata_Eventreport_Pain_Item51Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to compare against other tournaments for the same game`)
};

/**
* | output |
* | --- |
* | "I want to compare against other tournaments for the same game" |
*
* @param {Playdata_Eventreport_Pain_Item51Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_pain_item51 = /** @type {((inputs?: Playdata_Eventreport_Pain_Item51Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Pain_Item51Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_pain_item51(inputs)
	return en_playdata_eventreport_pain_item51(inputs)
});
export { playdata_eventreport_pain_item51 as "playdata_eventReport_pain_item5" }